const execSitejs = () => {
  if (typeof (window as any).kzs === 'function') {
    try {
      const current = (window as any).kzs.current;
      current.context.markerSiteJsTag.removeAttr('data-kz-applied-sitejs-id');
      current.location = new current.location.constructor(document.location);
      current.context.tracker.onUnload();
      current.context.startInsight();
    } catch (err) {
      console.error(err);
    }
  }
};

export default execSitejs;
